
import RegisterForm from 'pages/RegisterForm';
import ValidateToken from 'pages/ValidateToken';
import LoginForm from 'pages/LoginForm';
import { Routes, Route, Navigate } from 'react-router-dom';
import ForgotPassword from 'pages/ForgotPassword';
import SetNewPassword from 'pages/SetNewPassword';
import AppSelectionPage from 'pages/AppSelectionPage';
import ExitPage from 'pages/ExitPage';
import ExtraLivestockLogin from 'pages/ExtraLivestockLogin';
import InviteValidate from 'pages/InviteValidate';
import UsersPage from 'pages/Users';
import FarmDetails from './pages/FarmDetails';
import OrganisationsPage from './pages/Organisations';
import OrganisationSetupWizard from './pages/Organisations/SetupWizard';

function RedirectLegacyOrganisationRoute() {
  return <Navigate to="/companies" replace />;
}

function RedirectAddFarmToCompaniesModal() {
  return <Navigate to="/companies" replace state={{ openAddFarm: true }} />;
}

const routes = (
  <Routes>
    <Route path="/" element={<LoginForm />} />
    <Route path="/exit" element={<ExitPage />} />
    <Route path="/extra-livestock-login" element={<ExtraLivestockLogin />} />
    <Route path="/register" element={<RegisterForm />} />
    <Route path="/validate" element={<ValidateToken />} />
    <Route path="/invite-validate" element={<InviteValidate />} />
    <Route path="/forgot" element={<ForgotPassword />} />
    <Route path="/setNewPassword" element={<SetNewPassword />} />
    <Route path="/app-selection" element={<AppSelectionPage />} />
    <Route path="/register-farm" element={<Navigate to="/companies/setup" replace />} />
    <Route path="/farm-details" element={<FarmDetails />} />
    <Route path="/users" element={<UsersPage />} />
    <Route path="/companies" element={<OrganisationsPage />} />
    <Route path="/companies/setup" element={<OrganisationSetupWizard />} />
    <Route path="/companies/farms/new" element={<RedirectAddFarmToCompaniesModal />} />
    <Route path="/companies/:companyId" element={<Navigate to="/companies" replace />} />
    <Route path="/companies/:companyId/farms/new" element={<RedirectAddFarmToCompaniesModal />} />
    <Route path="/organisations" element={<Navigate to="/companies" replace />} />
    <Route path="/organisations/setup" element={<Navigate to="/companies/setup" replace />} />
    <Route path="/organisations/:orgId" element={<RedirectLegacyOrganisationRoute />} />
    <Route path="/organisations/:orgId/companies/:companyId" element={<Navigate to="/companies" replace />} />
    <Route path="/organisations/:orgId/farms/new" element={<RedirectAddFarmToCompaniesModal />} />
    <Route path="/organisations/:orgId/companies/:companyId/farms/new" element={<RedirectAddFarmToCompaniesModal />} />
    <Route path="/register-farm-summary" element={<Navigate to="/app-selection" replace />} />
    <Route path="*" element={<RegisterForm />} />
  </Routes>
);

export default routes;
